import type { ReactNode } from "react";
import { Cap } from "./Cap.tsx";
import { gitsAndVehiclesDialog } from "./style.css.ts";

export function CapsOverviewBanner(props: {
  cost: number;
  diff?: number;
  label: string;
  additionalInfo: string;
  isInvalid?: boolean;
  children: ReactNode;
}) {
  const { cost, label, additionalInfo, isInvalid, diff, children } = props;

  return (
    <div className={gitsAndVehiclesDialog.note({ isInvalid })}>
      <div style={{ marginBlock: "-1rem" }}>
        <Cap
          tilt="start"
          cost={cost}
          label={label}
          diff={diff}
          additionalInfo={additionalInfo}
          size="clamp(6rem, 20vw, 7rem)"
        />
      </div>

      <div style={{ paddingBlock: "1.5rem" }}>{children}</div>
    </div>
  );
}
